import type { Release } from '../releases';

export default {
  id: '2026-11-01-budget-compare',
  at: '2026-11-01T11:03:00Z',
  title: 'Сравнение версий бюджета',
  modules: ['budget'],
  items: [
    'На вкладке «Бюджет и маржа» появился блок «Сравнение версий»: выберите другую версию бюджета — портал покажет, какие разделы, статьи и варианты исполнения изменились, с суммами «было → стало».',
    'Видно добавленные и убранные строки, снятый или новый выбор варианта исполнения и недели, где изменился план оплат.',
  ],
  why: 'Чтобы понять, чем новая версия бюджета отличается от прежней, приходилось сравнивать их вручную.',
  link: '/projects',
} satisfies Release;
